import {call, put} from "typed-redux-saga";
import {Api} from "modules/utils";
import {
	fetchChecksumsJSONFailed,
	fetchChecksumsJSONSuccess,
	fetchCountriesFailed,
	fetchCountriesSuccess,
	fetchFAQJsonFailed,
	fetchFAQJsonSuccess,
	fetchHelpPagesJsonFailed,
	fetchHelpPagesJsonSuccess,
	fetchSettingsFailed,
	fetchSettingsSuccess,
} from "modules/actions";
import {IApiErrorResponse, IFaq, IHelpPages} from "modules/reducers";

export const fetchChecksumsJSONSaga = function* () {
	try {
		const result = yield* call(Api.JSON.checksums);
		yield* put(fetchChecksumsJSONSuccess(result));
	} catch (err) {
		yield* put(fetchChecksumsJSONFailed());
	}
};

export const fetchHelpPagesJSONSaga = function* () {
	try {
		const response = yield* call(Api.JSON.helpPages);

		const errorResponse = response as IApiErrorResponse;
		if (errorResponse.code && errorResponse.code !== 200) {
			throw new Error(errorResponse.message);
		}

		const result = response as IHelpPages;
		yield* put(fetchHelpPagesJsonSuccess(result));
	} catch (e) {
		yield* put(fetchHelpPagesJsonFailed());
	}
};

export const fetchFAQJSONSaga = function* () {
	try {
		const response = yield* call(Api.JSON.faq);

		const errorResponse = response as IApiErrorResponse;
		if (errorResponse.code && errorResponse.code !== 200) {
			throw new Error(errorResponse.message);
		}

		const result = response as IFaq[];
		yield* put(fetchFAQJsonSuccess(result));
	} catch (e) {
		yield* put(fetchFAQJsonFailed());
	}
};

export const fetchHelpPageJsonsSaga = function* () {
	yield* call(fetchHelpPagesJSONSaga);
	yield* call(fetchFAQJSONSaga);
};

export const fetchCountriesSaga = function* () {
	try {
		const response = yield* call(Api.JSON.countries);
		yield* put(fetchCountriesSuccess(response));
	} catch (e) {
		yield* put(fetchCountriesFailed());
	}
};

export const fetchTranslatedCountriesSaga = function* () {
	try {
		const response = yield* call(Api.JSON.translatedCountries);
		yield* put(fetchCountriesSuccess(response));
	} catch (e) {
		yield* put(fetchCountriesFailed());
	}
};

export const fetchSettingsSaga = function* () {
	try {
		const response = yield* call(Api.JSON.settings);
		yield* put(fetchSettingsSuccess(response));
	} catch (e) {
		yield* put(fetchSettingsFailed());
	}
};
